module.exports = __webpack_public_path__ + "img/2025-12-20g_1.b3b4a594.jpg";